import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DeliveryAddress {
  address: string;
  location?: {
    latitude: number;
    longitude: number;
  };
  tag?: string;
  isInsideDeliveryZone?: boolean;
}

interface DeliveryCarts {
  expressCarts?: Array<{
    cartId: string;
    distanceInKm: number;
  }>;
  standardCart?: {
    cartId: string;
    distanceInKm: number;
  };
}

interface OrderTypeState {
  orderType: "Delivery" | "Pickup" | null;
  selectedCartId: string | null;
  hasSelectedOrderType: boolean;
  deliveryAddress: DeliveryAddress | null;
  isScheduleOrder: boolean;
  scheduledDate: string | null;
  scheduledTime: string | null;
  organizationId?: string | null;
  deliverySources: DeliveryCarts | null;
}

const initialState: OrderTypeState = {
  orderType: null,
  selectedCartId: null,
  hasSelectedOrderType: false,
  deliveryAddress: null,
  isScheduleOrder: false,
  scheduledDate: null,
  scheduledTime: null,
  organizationId: null,
  deliverySources: null,
};

const orderTypeSlice = createSlice({
  name: "orderType",
  initialState,
  reducers: {
    setOrderType: (
      state,
      action: PayloadAction<{ 
        orderType: "Delivery" | "Pickup"; 
        cartId?: string;
        isScheduleOrder?: boolean;
        scheduledDate?: string;
        scheduledTime?: string;
        organizationId?: string | null;
      }>
    ) => {
      state.orderType = action.payload.orderType;
      state.selectedCartId = action.payload.cartId || null;
      state.hasSelectedOrderType = true;
      state.isScheduleOrder = action.payload.isScheduleOrder || false;
      state.scheduledDate = action.payload.scheduledDate || null;
      state.scheduledTime = action.payload.scheduledTime || null;
      state.organizationId = action.payload.organizationId || null;
      
      // Clear delivery address when switching to pickup
      if (action.payload.orderType === "Pickup") {
        state.deliveryAddress = null;
      }
    },
    setDeliveryAddress: (state, action: PayloadAction<DeliveryAddress>) => {
      state.deliveryAddress = action.payload;
    },
    setDeliverySources: (state, action: PayloadAction<DeliveryCarts>) => {
      state.deliverySources = action.payload;
    },
    clearOrderType: (state) => {
      state.orderType = null;
      state.selectedCartId = null;
      state.hasSelectedOrderType = false;
      state.deliveryAddress = null;
      state.isScheduleOrder = false;
      state.scheduledDate = null;
      state.scheduledTime = null;
      state.organizationId = null;
      state.deliverySources = null;
    },
    clearOrderTypeKeepAddress: (state) => {
      state.orderType = null;
      state.selectedCartId = null;
      state.hasSelectedOrderType = false;
      // Keep deliveryAddress intact
      state.isScheduleOrder = false;
      state.scheduledDate = null;
      state.scheduledTime = null;
      state.organizationId = null;
      state.deliverySources = null;
    },
    clearOrderTypeKeepCart: (state) => {
      state.orderType = null;
      // Keep selectedCartId intact
      state.hasSelectedOrderType = false;
      state.deliveryAddress = null;
      state.isScheduleOrder = false;
      state.scheduledDate = null;
      state.scheduledTime = null;
      state.organizationId = null;
      state.deliverySources = null;
    },
  },
});

export const { setOrderType, setDeliveryAddress, setDeliverySources, clearOrderType, clearOrderTypeKeepAddress, clearOrderTypeKeepCart } = orderTypeSlice.actions;
export default orderTypeSlice.reducer;
